import { axios } from '../../utils/request'
import path from '../../api/path'

export function saveDrafRequest (typeFlags, params) {
  const url = '/' + path.apiName + '/carrier-case/' + typeFlags + '/draft'
  return axios({
    url: url,
    method: 'post',
    data: params,
    headers: {
      patch: {
        'Content-Type': 'multipart/form-data'
      },
      post: {
        'Content-Type': 'multipart/form-data'
      },
      put: {
        'Content-Type': 'multipart/form-data'
      },
      'Content-Type': 'multipart/form-data'
    },
    redirect: 'follow'
  })
}

export function commiteRequest (typeFlags, params) {
  const url = '/' + path.apiName + '/carrier-case/' + typeFlags + '/establish'
  return axios({
    url: url,
    method: 'post',
    data: params,
    headers: {
      path: {
        'Content-Type': 'multipart/form-data'
      },
      post: {
        'Content-Type': 'multipart/form-data'
      },
      put: {
        'Content-Type': 'multipart/form-data'
      },
      'Content-Type': 'multipart/form-data'
    },

    redirect: 'follow'
  })
}

export function getViewDetail (uuid) {
  const url = '/' + path.apiName +  path.php + '/shipment-handing/detail/' + uuid
  return axios({
    url: url,
    method: 'get'
  })
}

export function getNewViewDetail (caseId, buType) {
  const url = '/' + path.apiName +  path.php + '/case-define/' + caseId + '/' + buType + '/fields'
  return axios({
    url: url,
    method: 'get'
  })
}
